/**
 * Created by Bas on 01/25/2024.
 */
import {Component, Inject, ViewChild} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {LoadingButtonComponent} from 'app/shared/loading-button/button';
import {Toast} from '../../shared/toast/toast';

@Component({
   selector: 'app-change-company-logo',
   templateUrl: 'change-company-logo.component.html',
   styleUrls: ['change-company-logo.component.css']
})
export class ChangeCompanyLogoComponent {
   @ViewChild('ok') button: LoadingButtonComponent;
   imageData: any;
   logo: File;
   size = 2097152;

   constructor(private dialogRef: MatDialogRef<ChangeCompanyLogoComponent>,
               @Inject(MAT_DIALOG_DATA) private data: any, private service: IdexService, private toast: Toast) {
   }

   selectCompanyLogo(event: any) {
      const imageType = /image\/jpg|png|jpeg/;
      if (event.target.files && !event.target.files[0].type.match(imageType) || event.target.files[0].size > this.size) {
         this.data.translate.get('alert.logo_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      if (event.target?.files[0] && event.target.files[0].size < this.size) {
         this.logo = event.target.files[0];
         this.loadPreview();
      }
   }

   changeLogo() {
      this.service.updateLogo(this.logo,this.data.id,this.data.tin,this.data.alignment)
         .subscribe(data => {
            this.dialogRef.close();
         }, () => {
            this.button.reset();
         });
   }

   onDragOver(event: DragEvent) {
      const data = event.dataTransfer;
      let hasFiles = false;
      if (data.items && data.items.length === 1) {
         const imageType = /image\/jpg|png|jpeg/;
         if (RegExp(imageType).exec(data.items[0].type)) {
            hasFiles = true;
         }
      }
      if (hasFiles) {
         event.preventDefault();
         event.stopPropagation();
         event.dataTransfer.dropEffect = 'copy';
      }
   }

   onDrop(event: DragEvent) {
      event.preventDefault();
      event.stopPropagation();
      if (event.dataTransfer.items[0].getAsFile().size > this.size) {
         this.data.translate.get('alert.logo_error').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      if (event.dataTransfer?.items[0].getAsFile()) {
         this.logo = event.dataTransfer.items[0].getAsFile();
         this.loadPreview();
      }
   }

   private loadPreview() {
      const reader = new FileReader();
      reader.onload = (e: any) => {
         this.imageData = e.target.result;
      };
      reader.readAsDataURL(this.logo);
   }
}
